import injectSheet from 'react-jss'
import ChangesDisclaimer from './ChangesDisclaimer'
import styles from './ChangesDisclaimer.styles'

export default injectSheet(styles)(ChangesDisclaimer)
